import React from "react";
import Icon from "@ant-design/icons";

const SpeakerMuteIconSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#667085"
      d="M15.737 13.55V5.977c0-.565-.415-1.017-.995-1.017-.384 0-.655.166-1.07.557L10.75 8.223c-.03.03-.068.053-.106.053h-.188l5.28 5.273zm2.636 5.634a.603.603 0 00.844 0 .605.605 0 000-.851L6.02 5.142a.607.607 0 00-.86 0 .61.61 0 000 .843l13.215 13.2zM8.181 14.905h2.124c.068 0 .128.023.173.068l3.195 2.968c.376.362.693.52 1.077.52.437 0 .768-.226.919-.67L6.892 9.02c-.256.287-.391.709-.391 1.266v2.863c0 1.175.572 1.755 1.68 1.755z"
    ></path>
  </svg>
);

const SpeakerMuteIcon = (props) => (
  <Icon component={SpeakerMuteIconSvg} {...props} />
);

export default SpeakerMuteIcon;
